import classNames from 'classnames';
import { type FC, type PropsWithChildren, useRef, useState } from 'react';

import styles from './DraggableScroll.module.scss';

type DraggableScrollProps = PropsWithChildren & {
  className?: string;
};

const DraggableScroll: FC<DraggableScrollProps> = ({ children, className }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    const rect = ref.current?.getBoundingClientRect();
    const startX = e.clientX - (rect?.left || 0);
    setStartX(startX);
    setScrollLeft(ref.current?.scrollLeft || 0);
    e.preventDefault();
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging) return;
    const rect = ref.current?.getBoundingClientRect();
    const x = e.clientX - (rect?.left || 0);
    const walk = (x - startX) * 1;
    if (ref.current) {
      ref.current.scrollLeft = scrollLeft - walk;
    }
    e.preventDefault();
  };

  const handleMouseUpOrLeave = () => {
    setIsDragging(false);
  };

  return (
    <div
      ref={ref}
      className={classNames(styles['draggable-scroll'], className, {
        [styles.dragging]: isDragging,
      })}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUpOrLeave}
      onMouseLeave={handleMouseUpOrLeave}
    >
      {children}
    </div>
  );
};

export default DraggableScroll;
